import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TenantNotFoundPage } from './core/tenant/tenant-not-found.page';
import { TenantService } from './core/tenant/tenant.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TenantNotFoundPage],
  template: `
    @if (tenant.loading()) {
      <div class="app-loading">Loading booking site...</div>
    } @else if (tenant.notFound()) {
      <app-tenant-not-found-page />
    } @else {
      <router-outlet />
    }
  `,
  styles: `
    .app-loading {
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #64748b;
      font-size: 0.9375rem;
    }
  `,
})
export class App {
  protected readonly tenant = inject(TenantService);
}
